import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '@store';
import {
  ButtonPrimary,
  ButtonPseudo,
  Popup,
  SidePanel,
  SidePanelLoader,
  SidePanelType,
} from '@ui/src';
import useCardOrder from './hooks/use-card-order';
import { OrganizationType } from '../types';
import OrderCardForm from '../../../components/common/cards/order';

const CustomerCardOrder = ({ type }: { type: OrganizationType }) => {
  const { customerId, cardId } = useParams();

  const { cardSubmitInProgress, cardSubmitSuccess, cardInfo, cardInfoLoading } =
    useAppSelector((state) => state.customerCards);
  const { countriesList: countries } = useAppSelector((state) => state.root);

  const {
    handleClose,
    control,
    errors,
    physical,
    setValue,
    panelIsOpen,
    isDirty,
    setDirtyPopupVisible,
    onSubmit,
    dirtyPopupVisible,
  } = useCardOrder({
    type,
    customerId,
    cardId,
    cardInfo,
    countries,
  });

  useEffect(() => {
    if (cardSubmitSuccess) {
      handleClose();
    }
  }, [cardSubmitSuccess]);

  let content;

  if (!cardInfoLoading) {
    content = (
      <OrderCardForm
        control={control}
        errors={errors}
        physical={physical}
        countries={countries}
        setValue={setValue}
      />
    );
  } else {
    content = <SidePanelLoader />;
  }

  let buttonText;

  if (cardSubmitInProgress) {
    buttonText = 'Loading...';
  } else {
    buttonText = 'Order a card';

    if (cardId) {
      buttonText = 'Save';
    }
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Cards}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title={cardId ? 'Edit card' : 'Order a card'}
        sidepanelExpandedKey="customers-card-panel"
        footer={
          <>
            <ButtonPrimary
              text={buttonText}
              onClick={cardId ? handleClose : onSubmit}
              disabled={cardSubmitInProgress}
              bold
            />
            <ButtonPseudo
              text="Close"
              onClick={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
              bold
            />
          </>
        }
      >
        {content}
      </SidePanel>
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <div id="dirty-popup" />
    </>
  );
};

export default CustomerCardOrder;
